import { ProgressiveBarService } from './../../shared/progressive-bar/progressive-bar.service';
import { DataEntry } from 'src/app/shared/data-entry.interface';
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { DataproviderService } from 'src/app/dataprovider.service';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss', './time.component.responsive.scss'],
  host: {
    class: 'd-block bg-standard p-b-104'
  }
})
export class TimeComponent implements OnInit {
  title: string    = "b2c.IDS_TIMES";
  subtitle: string = "b2c.IDS_TIMES_SUB";
  question: string = "b2c.IDS_TIMES_QUE";
  activePage: string = "times";
  nextPage: string = "summary";
  dataEntries: DataEntry[];
/*  dataEntries: DataEntry[] = [
    { ID:1, name:"b2c.IDS_2MONTHS", description: "", image: "../../assets/img/time/time-2months.svg", tooltip: "", checked: false},
    { ID:2, name:"b2c.IDS_4MONTHS", description: "", image: "../../assets/img/time/time-4months.svg", tooltip: "", checked: false},
    { ID:3, name:"b2c.IDS_6MONTHS", description: "", image: "../../assets/img/time/time-6months.svg", tooltip: "", checked: false},
    { ID:4, name:"b2c.IDS_MOREMONTHS", description: "", image: "../../assets/img/time/time-6months.svg", tooltip: "", checked: false}
  ];*/
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "";
  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(this.title, this.subtitle, this.question, this.activePage, this.nextPage, false, true, false, true,null,false,false,this.eventCategory,this.eventLabel);
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(10);
  }

  ngOnInit() {
    this.initSelection();
    this.wsCall();
  }

  initSelection() {
    this.dataEntries = this.ds.getDefaultTimes();
    let selectedDataEntry = this.ds.getTime();
    if (selectedDataEntry) {
      this.onSelectorClicked(selectedDataEntry.ID);
    }
  }

  wsCall(){
    /*var that = this;
    this.ws.calculatePointsByParams(this.ds.getHousingType(false), this.ds.getTechnologyID(), this.ds.getLocalizationID(), 1).subscribe( data => {
      that.ds.setTotalPoints(data);
    });*/
  }

  dataEntriesUpdate(idSelected: number){
    /* single selection */
    for (let data of this.dataEntries) {
      if ( data.ID == idSelected ) { data.checked = true; } else { data.checked = false; }
    }
    this.cs.updateNextBtn(true);
  }

  onSelectorClicked(idSelected: number){
    this.dataEntriesUpdate(idSelected);
    this.ds.setTime(this.dataEntries.find(time => {
      return time.ID == idSelected;
    }));
    if(this.ds.getShapeID()){
      this.eventLabel="IDS_TIMES_SHAPE_".concat(this.ds.getShapeID().toString()).concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString()));
    }else{
      this.eventLabel="IDS_TIMES".concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString())).concat("_FINISHING").concat(this.ds.getFinishingID().toString());
    }
    this.cs.setLabelEvent(this.eventLabel);


    let listChooise: [{ key: string; value: number; }];
    listChooise = this.cs.getOtherInfoFromSelector(this.dataEntries,idSelected,'STEP_4_');
    this.cs.setGASelectionEvent('step_4',listChooise);
  }

  canConfirm(){
    let f: boolean = false;
    for (let time of this.dataEntries) {
      if(time.checked){
        f = true;
      }
    }
    return f;
  }
}
